export default function StatusIndicator({ positive, icon, children, title }) {
  return <span className={`gull-status-indicator ${positive ? "is-connected" : "is-disconnected"}`}
    role="status" title={title}>
    {icon}{children}
  </span>;
}
